// extracted by mini-css-extract-plugin
export var table = "_wl-0";